/**
 * @generated SignedSource<<ac8e488f089fdc7810ba99e6c3a93093>>
 * @relayHash 3a2b6de25396328a7215eef4ddb9d1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SpaceSidebarLinkType = "EXTERNAL_LINK" | "FORGE" | "PINNED_ATTACHMENT" | "PINNED_BLOG_POST" | "PINNED_PAGE" | "PINNED_SPACE" | "PINNED_USER_INFO" | "WEB_ITEM" | "%future added value";
export type SpaceNavigationQuery$variables = {
  isLicensed: boolean;
  spaceKey?: string | null | undefined;
};
export type SpaceNavigationQuery$data = {
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser?: {
      readonly isAdmin: boolean;
      readonly isFavourited: boolean;
      readonly isWatched: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly history: {
      readonly createdDate: string | null | undefined;
    } | null | undefined;
    readonly homepage: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly status: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null | undefined;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null | undefined;
        readonly isDefault: boolean | null | undefined;
        readonly path: string;
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly iconClass: string | null | undefined;
      readonly id: string;
      readonly linkIdentifier: string | null | undefined;
      readonly position: number;
      readonly styleClass: string | null | undefined;
      readonly title: string | null | undefined;
      readonly tooltip: string | null | undefined;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null | undefined;
      readonly webItemCompleteKey: string | null | undefined;
      readonly webItemKey: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type SpaceNavigationQuery = {
  response: SpaceNavigationQuery$data;
  variables: SpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "position"
},
v6 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v7 = {
  "kind": "ScalarField",
  "name": "path"
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "SpaceSidebarLinks",
    "kind": "LinkedField",
    "name": "spaceSidebarLinks",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "includeHidden",
            "value": true
          }
        ],
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "main",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "webItemKey"
          },
          {
            "kind": "ScalarField",
            "name": "webItemCompleteKey"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "width"
              },
              {
                "kind": "ScalarField",
                "name": "height"
              },
              {
                "kind": "ScalarField",
                "name": "isDefault"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "iconClass"
          },
          {
            "kind": "ScalarField",
            "name": "hidden"
          },
          {
            "kind": "ScalarField",
            "name": "canHide"
          },
          {
            "kind": "ScalarField",
            "name": "tooltip"
          },
          {
            "kind": "ScalarField",
            "name": "linkIdentifier"
          },
          (v8/*: any*/)
        ],
        "storageKey": "main(includeHidden:true)"
      },
      {
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "quick",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      (v8/*: any*/),
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      },
      {
        "condition": "isLicensed",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isAdmin"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourited"
              },
              {
                "kind": "ScalarField",
                "name": "isWatched"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "containsExternalCollaborators"
      },
      {
        "concreteType": "SpaceHistory",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "didContainUserContent"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceNavigationQuery",
    "selections": (v9/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceNavigationQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "3a2b6de25396328a7215eef4ddb9d1c0",
    "id": "da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0",
    "metadata": {},
    "name": "SpaceNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceNavigationQuery($spaceKey:String,$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators,history{createdDate},didContainUserContent}}"
  }
};
})();

(node as any).hash = "bca4942401246f836068201b36fd61d7";

export default node;
